import React from "react";
import classnames from "classnames";
import PortalRender from "@appComponents/PortalRender/PortalRender";

import * as style from "./RiskBannerStyle.module.scss";

type Props = {
  isUk?: boolean;
};

const RiskBanner = ({ isUk = false }: Props) => {
  if (process.env.UK_RISK_MODAL_ENABLED?.toLowerCase() !== "true") {
    return null;
  }

  return (
    <PortalRender portalId="risk-banner-container">
      <div
        className={classnames(style.riskBanner, {
          [style.riskBannerUk]: isUk,
          [style.riskBannerNonUk]: !isUk,
        })}
      >
        <span>
          Don't invest unless you're prepared to lose all the money you invest.
          This is a high-risk investment and you should not expect to be
          protected if something goes wrong.{" "}
          <a
            href="https://bnktothefuture.com/uk-risk-disclaimer/"
            target="_blank"
            rel="noreferrer"
          >
            Take 2 mins to learn more.
          </a>
        </span>
      </div>
    </PortalRender>
  );
};

export default RiskBanner;
